// The encrypted-share on/off switch (cyan track when on, grey when off). One copy
// shared by the home page's share card and each History row. Purely
// presentational: the caller owns the on/busy/disabled state and the click.
//
// `busy` toggles the spinner styling (`.busy`) independently of `disabled`,
// because the home card can be disabled (nothing to share yet) without being busy.
export function ShareToggle({
  on,
  busy = false,
  disabled = false,
  ariaLabel,
  title,
  onClick,
}: {
  on: boolean;
  busy?: boolean;
  disabled?: boolean;
  ariaLabel: string;
  title?: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      title={title}
      className={`share-toggle${on ? " on" : ""}${busy ? " busy" : ""}`}
      disabled={disabled}
      onClick={onClick}
    >
      <span className="share-toggle-track">
        <span className="share-toggle-knob" />
      </span>
    </button>
  );
}

export default ShareToggle;
